import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration — production project (matches customer/go7 app)
const firebaseConfig = {
  apiKey: "AIzaSyAApbZP6QnaeMWP19cfK_XXRLlXlS7cP5s",
  authDomain: "go7-app-209e4.firebaseapp.com",
  projectId: "go7-app-209e4",
  storageBucket: "go7-app-209e4.firebasestorage.app",
  messagingSenderId: "64086226844",
  appId: "1:64086226844:web:cb8c67344e6241fe11fa59"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

// Set auth persistence to LOCAL - keeps user logged in across sessions
// This saves money by not requiring OTP every time
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set auth persistence:', error);
});

export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
